import {
  Box,
  Button,
  Stack,
  Table,
  Tbody,
  Text,
  Td,
  Tr,
  Image,
  VStack,
  Spinner,
} from '@chakra-ui/react';
import React from 'react';
import ErrImg from '../../../../assets/icons/error.svg';
import { useSingleProduct } from '../../../../services/apiURLs';

const StepTwo = ({ onClose, nextStep, previousStep, data, setProduct }) => {
  // console.log('inverter prod ', data);
  // console.log('id', data[0]?.productId);

  const { data: product, isLoading } = useSingleProduct(data[0]?.productId);

  const handleClick = () => {
    setProduct(product);
    nextStep();
  };

  return (
    <>
      {isLoading ? (
        <VStack spacing={16} mt={24}>
          <Spinner
            size={'xl'}
            thickness='10px'
            color='orange'
            width='200px'
            height='200px'
          />
          <Box textAlign={'center'}>
            <Text fontSize={'20px'} fontWeight={600} mb={4}>
              Please wait
            </Text>
            <Text fontSize={'14px'}>While we calculate your load capacity</Text>
          </Box>
          <Button
            w={'60%'}
            mt='16'
            onClick={onClose}
            border='1px solid #E53511'
            py={6}
            px={20}
            color={'#E53511'}
          >
            Cancel
          </Button>
        </VStack>
      ) : (
        <>
          {data?.length <= 0 ? (
            <Box my={8}>
              <Image src={ErrImg} alt='error' my={8} />
              <Text fontSize={'32px'} fontWeight={600} mb={8}>
                {'Ooops, try again'}
              </Text>
              <Button
                onClick={previousStep}
                border='1px solid #32C36C'
                py={6}
                px={20}
                color={'brand.10'}
              >
                Re-Calculate
              </Button>
            </Box>
          ) : (
            <Box my={8}>
              <Text fontSize={'32px'} fontWeight={600} mb={4}>
                Product Recommendation for you
              </Text>
              <Table mb={12} w={'80%'}>
                <Tbody>
                  <Tr>
                    <Td>
                      <Text fontSize={'14px'}>Inverter VA Rating - </Text>
                    </Td>
                    <Td>
                      <Text fontSize={'14px'}>
                        {data[0]?.minIvtCap !== null ? data[0]?.minIvtCap : 0}
                        VA
                      </Text>
                    </Td>
                  </Tr>
                  <Tr>
                    <Td>
                      <Text fontSize={'14px'}>Battery Capacity - </Text>
                    </Td>
                    <Td>
                      <Text fontSize={'14px'}>
                        {data[0]?.laBatQty !== null ? data[0]?.laBatQty : 0}
                      </Text>
                    </Td>
                  </Tr>
                  <Tr>
                    <Td>
                      <Text fontSize={'14px'}>Number of batteries - </Text>
                    </Td>
                    <Td>
                      <Text fontSize={'14px'}>
                        {data[0]?.lithiumBatQty !== null
                          ? data[0]?.lithiumBatQty
                          : 0}
                      </Text>
                    </Td>
                  </Tr>
                </Tbody>
              </Table>
              <Stack spacing={4}>
                <Button
                  onClick={handleClick}
                  fontSize={'14px'}
                  border='1px solid #32C36C'
                  py={6}
                  px={20}
                  colorScheme='green'
                >
                  Recommended Product Model
                </Button>
                <Button
                  onClick={previousStep}
                  border='1px solid #32C36C'
                  py={6}
                  px={20}
                  color={'brand.10'}
                >
                  Re-Calculate
                </Button>
              </Stack>
            </Box>
          )}
        </>
      )}
    </>
  );
};

export default StepTwo;
